var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='9' height='5' fill='none'%3e%3cpath stroke='%23000F00' d='m1 1 3.5 3L8 1'/%3e%3c/svg%3e";
  var caret = img;

export { caret as default };
//# sourceMappingURL=caret.svg.js.map
